import React from 'react';
import { useLocation } from 'react-router';
import { ChevronRight } from 'lucide-react';
import { LinkButton } from '@/shared/ui/button';
import { cn } from '@/shared/lib/cn';
import { useSiteContent } from '@personal-portfolio/queries';
import { navigationItems } from './navigation';
import { ResumeCard } from '@/features/resume-download/resume-card';

// Desktop-only sidebar; the Header's Sheet is the mobile navigation.
export const Sidebar: React.FC = () => {
  const content = useSiteContent();
  const { pathname } = useLocation();
  return (
    <aside
      aria-label="Site navigation"
      className="fixed top-14 left-0 z-40 hidden h-[calc(100dvh-3.5rem)] w-64 border-r bg-transparent lg:block"
    >
      <div className="flex h-full flex-col py-6">
        <div className="px-3 py-2">
          <h2 className="mb-3 px-4 font-mono text-xs font-medium tracking-widest text-muted-foreground uppercase">
            {content.chrome.brand}
          </h2>
          <nav aria-label="Main">
            <div className="space-y-1">
              {navigationItems.map((item) => {
                const isActive = pathname === item.path;
                return (
                  <LinkButton
                    key={item.path}
                    href={item.path}
                    variant={isActive ? 'secondary' : 'ghost'}
                    className={cn(
                      'w-full justify-start transition-colors duration-150',
                      isActive
                        ? 'font-medium'
                        : 'text-muted-foreground hover:text-foreground',
                    )}
                  >
                    <item.icon className="mr-2 h-4 w-4" />
                    {content.nav[item.titleKey]}
                    {isActive && <ChevronRight className="ml-auto h-4 w-4" />}
                  </LinkButton>
                );
              })}
            </div>
          </nav>
        </div>

        <div className="flex-1" />

        {/* Tablet only; at xl the resume card lives in the right sidebar
            instead, so it must be hidden here to avoid rendering twice. */}
        <div className="mx-6 mb-2 xl:hidden">
          <ResumeCard />
        </div>
      </div>
    </aside>
  );
};
